import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { modifyFilterList } from "../../../page/FilterPage/FilterSlice.js";
import { useState, useEffect } from "react";

export const FilterPagination = (props) => {
  let dispatch = useDispatch();
  let filterResultList = useSelector((state) => state.filter.filterResultList);
  let totalPages = filterResultList.totalPages;
  let currentPage = useSelector((state) => state.filter.filterList.page);
  let [redirectPage, setRedirectPage] = useState(currentPage);

  if (totalPages > 500){
    totalPages = 500;
  }

  useEffect(() => {
    dispatch(
      modifyFilterList({
        field: "page",
        payload: redirectPage,
      })
    );
  }, [redirectPage]);

  function handlePagination (redirect_page) {
    setRedirectPage(redirect_page);
  }

  return (
    <div className="filter_pagination_wrapper">
      <div className="pagination_section_wrapper">
        <div
          className={`pagination_item pagination_first ${
            currentPage == 1 ? "pagination_inactive" : ""
          }`}
          onClick={() => setRedirectPage(1)}
        >
          <i className="fa-solid fa-angles-left"></i>
          <span>First Page</span>
        </div>
        <div
          className={`pagination_item pagination_back ${
            currentPage == 1 ? "pagination_inactive" : ""
          }`}
          onClick={() => setRedirectPage(currentPage - 1)}
        >
          <i className="fa-solid fa-angle-left"></i>
          <span>Previous Page</span>
        </div>
      </div>
      <div className="pagination_section_wrapper">
        <div className="pagination_content">
          Page {currentPage}/{totalPages}
        </div>
      </div>
      <div className="pagination_section_wrapper">
        <div
          className={`pagination_item pagination_next ${
            currentPage == totalPages ? "pagination_inactive" : ""
          }`}
          onClick={() => setRedirectPage(currentPage + 1)}
        >
          <i className="fa-solid fa-angle-right"></i>
          <span>Next Page</span>
        </div>
        <div
          className={`pagination_item pagination_last ${
            currentPage == totalPages ? "pagination_inactive" : ""
          }`}
          onClick={() => setRedirectPage(totalPages)}
        >
          <i className="fa-solid fa-angles-right"></i>
          <span>Last Page</span>
        </div>
      </div>
    </div>
  );
};
